import React from 'react';
import { Container, NotificationDot } from './elements';

type NotiDotProps = {
  readonly className?: string;
  readonly show: boolean;
};

export default function NotiDot({ className, show }: NotiDotProps) {
  return (
    <Container className={className}>
      <NotificationDot $show={show} />
    </Container>
  );
}
